import { useEffect, useState } from 'react';

import { checkIsOrderCancelled } from 'utils/orderUtils';

import { Async, Status } from '../../../../core/types/data.types';
import { useInterval } from '../../../../utils/hooks/useInterval';
import { PreviousOrderDm } from '../../../../weborder/Api';
import { orderApiServices } from '../../../../weborder/services';

interface UseOrder {
  data: PreviousOrderDm;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useOrder = (orderId: number): UseOrder => {
  const [order, setOrder] = useState<Async<PreviousOrderDm>>({
    status: Status.LOADING,
  });

  const isError = order.status === Status.ERROR;
  const isLoading = order.status === Status.LOADING;
  const isSuccess = order.status === Status.SUCCESS;
  const data = isSuccess ? order.data : null;

  const fetchOrder = (): Promise<void> =>
    orderApiServices
      .get({ orderId })
      .then((orderData) => {
        if (orderData) {
          setOrder({ data: orderData, status: Status.SUCCESS });
        }
      })
      .catch((_error) => {
        setOrder({ status: Status.ERROR });
      });

  const loadReceipt = (): void => {
    if (isSuccess && !checkIsOrderCancelled(order.data.OrderState)) {
      fetchOrder();
    }
  };

  useEffect(() => {
    if (order.status === Status.LOADING) {
      fetchOrder();
    }
  }, [order.status, orderId]);

  const noReceiptCode = isSuccess && !order.data.ReceiptCode;

  // TO DO: Remove this when we have a better solution - ORD-1046
  useInterval(loadReceipt, noReceiptCode ? 10000 : null);

  return {
    data,
    isError,
    isLoading,
    isSuccess,
  };
};
